import { render, staticRenderFns } from "./BasicCustomField.vue?vue&type=template&id=d11983e0"
import script from "./BasicCustomField.vue?vue&type=script&lang=js"
export * from "./BasicCustomField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports